import EmailInputElement from "@/components/input/v1/EmailInputElement"
import PasswordInputElement from "@/components/input/v1/PasswordInputElement"
import { Button } from "@/components/ui/button"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import FormBox from "@/features/shared/components/FormBox"
import { PasswordInputIcon } from "@/utils/enums/PasswordInputIcon"
import { PasswordInputType } from "@/utils/enums/PasswordInputType"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EMAIL_REGEX, PASSWORD_REGEX } from "../../../../utils/Constants"

interface Props {
    onSubmit: (inputData: { [key: string]: string }) => void;
    passwordError: string,
}

const LoginBox: React.FC<Props> = ({
    onSubmit,
    passwordError,
}) => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()

    const [inputs, setInputs] = useState<{ [key: string]: string }>({
        email: '',
        password: '',
    });

    const [emailError, setEmailError] = useState("")
    const [pwdError, setPwdError] = useState(passwordError)

    const isEmailAcceptable = EMAIL_REGEX.test(inputs.email)
    const isPasswordAcceptable = PASSWORD_REGEX.test(inputs.password)

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // Ensure the value is in lowercase for the email field
        const formattedValue = name === "email" ? value.toLowerCase() : value;

        if (name === "email") {
            if (EMAIL_REGEX.test(e.target.value) || value === "") {
                setEmailError("")
            } else {
                setEmailError("Inserisci un indirizzo email valido")
            }
        }

        if (pwdError !== "") {
            setPwdError("")
        }

        setInputs((prev) => ({
            ...prev,
            [name]: formattedValue,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(inputs);
    };

    const handleForgotPassword = async () => {
        navigate("/forgot-password")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "can't_login" },
        });
    }

    useEffect(() => {
        setPwdError(passwordError)
    }, [passwordError])

    // ********************************************************************************

    return (
        <FormBox
            description={"Inserisci le tue credenziali per accedere al mondo Holifya"}
            formContent={
                <>
                    <EmailInputElement
                        name="email"
                        label="Indirizzo e-mail"
                        placeholder="nome@esempio.com"
                        inputValue={inputs.email}
                        errorText={emailError}
                        onChange={handleInputChange}
                    />
                    <PasswordInputElement
                        name="password"
                        label="Password"
                        placeholder="Password"
                        inputValue={inputs.password}
                        disabled={!isEmailAcceptable || inputs.email === ""}
                        image={PasswordInputIcon.ShowDisabled}
                        type={PasswordInputType.Password}
                        errorText={pwdError}
                        toggleTypeEnabled={isEmailAcceptable && inputs.password !== ""}
                        onIconClick={() => console.log()}
                        onChange={handleInputChange}
                        autoComplete="current-password"
                    />
                    <Button
                        size={'form'}
                        disabled={!isPasswordAcceptable || !isEmailAcceptable}
                    >
                        Accedi
                    </Button>
                </>
            }
            actionButton={
                <Button
                    variant={'white'}
                    size={'form'}
                    onClick={handleForgotPassword}
                >
                    Non riesci ad accedere?
                </Button>
            }
            onSubmit={handleSubmit}
        />
    )
}

export default LoginBox
